import { getGioParams, sendGioData } from './gioIndex';
import { getQueryString, getChannelName } from './index';
/**
 *
 * @param {string} type
 * @returns
 */
export const gioClick = (type, params, eventName = 'DF_elementClick', cache = false) => {
  try {
    const { pathname, search } = location;
    const isJDYX = pathname === '/jdyx' || search.indexOf('channel=jdyx') > -1;
    // let Jingdong=location.href.indexOf('jdyx')!==-1
    // let channelId = location.href.indexOf('channelId=999')!==-1
    // 去判断pagename
    let newParams = params || {};
    newParams.pageType = '电影';
    if (!params?.pagename) {
      newParams.pagename = '电影';
    }
    newParams.pageUrl = window.location.href;
    let obj = getGioParams(type);
    // 底部导航埋点：
    let isType = type && type !== null && type !== undefined && type !== '';
    let HPbanenrNum = isType && ['点击首页', '点击分类', '点击购物车', '点击我的'].findIndex((v) => v === type);
    // 通过来查找是否存在底部导航的字段来合并相应对象
    let mergeObj = HPbanenrNum && HPbanenrNum === -1 ? Object.assign(obj, newParams) : Object.assign(obj, newParams, { HPbanenrNum: HPbanenrNum + 1 });
    let objs = {};
    for (const key in mergeObj) {
      objs['df_' + key] = mergeObj[key];
    }
    if (cache) {
      let newExposureItem = {
        ...objs,
        df_layoutCode: getQueryString('layoutcode') || '',
        df_openid: getQueryString('openid') || '',
        enterViewportTime: new Date().getTime()
      };
      // 调公共方法
      window.setGioExposureData?.({ ...newExposureItem, enterViewportTime: new Date().getTime(), ...getCommonParams() });
    } else {
      sendGioData(eventName, { ...objs, df_layoutCode: getQueryString('layoutcode') || '', df_openid: getQueryString('openid') || '' });
    }
    // sendGioData(eventName, objs);
    // debugger
  } catch (error) {
    console.log(error);
  }
};
/**
 * 获取二级分类标题
 * @param {string} subTitleArr //二级分类标题数组
 * @param {Object} goodsVal //商品信息
 * @returns
 */
const subTitleFn = (subTitleArr, goodsVal) => {
  let subTitleObj = subTitleArr && subTitleArr.length >= 1 && subTitleArr.filter((v) => v.id === goodsVal?.categoryId);
  return subTitleObj && subTitleObj[0]?.name;
};
/**
 * 全部多规格面板函数
 * @param {string} value //触发事件名
 * @param {Object} props //props
 * @param {String} numType // type 数量加、减、输入
 * @param {Boolean} btnInfo // btnInfo 加购及立即购买按钮，需要传搜索数据和金额频道信息等
 * @param {String} orderNum // 订单金额
 * @returns
 */
export const gioFaceplate = (value, props, numType, btnInfo, orderNum) => {
  try {
    const { name = '', categoryName = '', product: { goodsId = '', goodsName = '', spuId = '', mallSpuId = '', categoryId = 0 }, categoryObj, product, title, categoryDtos, contentSubtitleHidden = false, pageName } = JSON.parse(props);
    const isCategoryName = categoryName && categoryName !== null && categoryName !== undefined && categoryName !== '';
    // 判断当前是否为二级活动页
    const gioIsPathname = location.pathname.indexOf('/activity/products') !== -1;
    // 判断当前是否在京东优选频道
    const { pathname, search } = window.location;
    const isJDYX = pathname === '/jdyx' || search.indexOf('channel=jdyx') > -1;
    // 通过传来的二级分类数组查询当前商品的二级分类
    let categoryValue = categoryDtos && categoryDtos[999]?.filter((v) => v.id === categoryId)[0]?.name;
    const isHome = pathname === '/tmall/home' || search.indexOf('channel=/tmall/home') > -1;
    let keyword = getQueryString('keyword');
    let params = {};
    if (!isCategoryName && spuId) {
      params = {
        content: gioIsPathname ? title : isCategoryName ? categoryName : name,
        contentSubtitle: contentSubtitleHidden ? '' : gioIsPathname ? '列表商品' : '普通楼层',
        goodsname: goodsName || product.name,
        spu_code: spuId || mallSpuId,
        sku_code: goodsId
      };
      // gioClick(value||'',{
      //   // 判断活动页和活动二级页
      //   content:gioIsPathname?title:isCategoryName?categoryName:name,
      //   contentSubtitle:gioIsPathname?'列表商品':'普通楼层',
      //   goodsname:goodsName || product.name,
      //   spu_code:spuId||mallSpuId,
      //   sku_code:goodsId,
      //   pagename:props.pageNmae
      // })
    } else {
      if (categoryObj === undefined) {
        // 判断频道首页和京东分类页
        if (isJDYX) {
          params = {
            firstCategory: categoryValue,
            contentSubtitle: contentSubtitleHidden ? '' : '列表商品',
            goodsname: goodsName || product.name,
            spu_code: spuId || mallSpuId,
            sku_code: goodsId
          };
          // gioClick(value||'',{
          //   firstCategory:categoryValue,
          //   contentSubtitle:'列表商品',
          //   goodsname:goodsName || product.name,
          //   spu_code:spuId||mallSpuId,
          //   sku_code:goodsId
          // })
        } else {
          params = {
            content: isCategoryName ? categoryName : name,
            contentSubtitle: contentSubtitleHidden ? '' : '商品列表',
            goodsname: goodsName || product.name,
            spu_code: spuId || mallSpuId,
            sku_code: goodsId
          };
          // gioClick(value||'',{
          //   content:isCategoryName?categoryName:name,
          //   contentSubtitle:'商品列表',
          //   goodsname:goodsName || product.name,
          //   spu_code:spuId||mallSpuId,
          //   sku_code:goodsId
          // })
        }
      } else {
        // 二级分类页
        let subTitle = subTitleFn(categoryObj?.subCategoryList, product);
        if (isJDYX) {
          params = {
            firstCategory: categoryValue,
            contentSubtitle: contentSubtitleHidden ? '' : '列表商品',
            goodsname: goodsName || product.name,
            spu_code: spuId || mallSpuId,
            sku_code: goodsId
          };
          // gioClick(value||'',{
          //   firstCategory:categoryValue,
          //   contentSubtitle:'列表商品',
          //   goodsname:goodsName || product.name,
          //   spu_code:spuId||mallSpuId,
          //   sku_code:goodsId
          // })
        } else {
          params = {
            firstCategory: categoryObj?.name,
            secondCategory: subTitle,
            contentSubtitle: contentSubtitleHidden ? '' : '列表商品',
            goodsname: goodsName || product.name,
            spu_code: spuId || mallSpuId,
            sku_code: goodsId
          };
          // gioClick(value||'',{
          //   firstCategory:categoryObj?.name,
          //   secondCategory:subTitle,
          //   contentSubtitle:'列表商品',
          //   goodsname:goodsName || product.name,
          //   spu_code:spuId||mallSpuId,
          //   sku_code:goodsId
          // })
        }
      }
    }
    if (name && !params.contentTitle) {
      params.contentTitle = name;
    }
    if (pageName) {
      params.pagename = pageName;
    }
    if (numType) {
      params.status = numType;
    }
    if (btnInfo) {
      params.orderAmount = orderNum;
      params.goodsChannel = getChannelName(product.channel);
      params.goodsChannelId = product.channel;
    }
    // 从搜索转化而来
    if (keyword) {
      params.transform = '搜索';
      params.searchKeyword = keyword;
    }
    gioClick(value || '', params);
  }
  catch (error) {
    console.log(error);
  }
};

/**
 * 点击加购和点击商品函数
 * @param {Object} spuItem //商品信息
 * @param {number} num //判断购物车调用还是商品调用
 * @param {Object} props //props
 * @returns
 */
export const addCartVal = (spuItem, num, props) => {
  const { goodsName, spuId, goodsId, goodsType, mallSpuId } = spuItem;
  const { categoryObj } = props;
  // 当是二级分类页时 传入数组去筛选出二级分类标题
  let subTitleObj = categoryObj && categoryObj?.subCategoryList?.length >= 1 && categoryObj?.subCategoryList.filter((v) => v.id === spuItem?.categoryId);
  let subTitle = subTitleObj && subTitleObj[0]?.name;
  // 因为此方法是点击购物车和点击商品公用 所以通过传入的num不同去赋值不同的goodsType
  let goodsTypeObj = num === 0 ? { goodsType: goodsType === 0 ? '实体' : '电子券' } : {};
  // 判断当前是否为二级活动页
  let isPathname = location.pathname.indexOf('activity/products') !== -1;
  // 判断当前是否为京东优选频道 如果为京东优选频道 传入参数会有所变化
  if (!subTitle) {
    const { pathname, search } = window.location;
    const isJDYX = pathname === '/jdyx' || search.indexOf('channel=jdyx') > -1;
    // let Jingdong=location.href.indexOf('jdyx')!==-1
    // let channelId = location.href.indexOf('channelId=999')!==-1
    let obj = {};
    if (isJDYX) {
      obj = {
        goodsname: goodsName,
        spu_code: spuId || mallSpuId || null,
        sku_code: goodsId,
        content: props.categoryName,
        ...goodsTypeObj
      };
    } else {
      obj = {
        goodsname: goodsName,
        spu_code: spuId || mallSpuId || null,
        sku_code: goodsId,
        content: props.categoryName,
        ...goodsTypeObj
      };
    }
    isPathname ? delete obj.content : '';
    return obj;
  } else {
    return {
      goodsname: goodsName,
      spu_code: spuId || mallSpuId || null,
      sku_code: goodsId,
      firstCategory: props.categoryName,
      secondCategory: subTitle,
      ...goodsTypeObj
    };
  }
};

export const gioUrl = (url) => {
  if (!url || url === '') {
    return '';
  }
  const origin = window.location.origin;
  const isHttp = url && url.indexOf('http') !== -1;
  const strIndex = url.indexOf('http');
  return isHttp && strIndex <= 6 ? url : origin + url;
};
